<template>
  <div class="h100-40 h-scroll">
    <ejs-grid ref="grid">
      <e-columns>
        <e-column
          field="operName"
          isPrimaryKey="true"
          :headerText='$t("System.oprName")'
          width="120"
          textAlign="center"
        ></e-column>
        <e-column
          field="returnDate"
          isPrimaryKey="true"
          :headerText='$t("System.dataNameOrFtpPath")'
          width="120"
          textAlign="center"
          clipMode='EllipsisWithTooltip'
        ></e-column>
        <e-column
          field="useTime"
          isPrimaryKey="true"
          :headerText='$t("System.takeTimeWithUnit")'
          width="120"
          textAlign="center"
        ></e-column>
        <e-column
          field="result"
          isPrimaryKey="true"
          :headerText='$t("System.result")'
          width="120"
          textAlign="center"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
export default {
  name: "Result",
  props: {
    result: Array
  },
  data() {
    return {};
  },
  methods: {
    setDataSource(){
      this.$refs.grid.ej2Instances.dataSource = this.result;
    }
  },
  watch: {
    result() {
      this.setDataSource();
      deep: true;
    }
  }
};
</script>
